import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../environments/environment';

/**
 * Blocks entry to a product area that is disabled for the current environment
 * (`adminEnabled` / `internalEnabled` in environment.ts). Runs before the role
 * guards so a disabled product is unreachable regardless of the user's role.
 */
export const adminEnabledGuard: CanActivateFn = () => {
  return environment.adminEnabled ? true : inject(Router).createUrlTree(['']);
};

export const internalEnabledGuard: CanActivateFn = () => {
  return environment.internalEnabled ? true : inject(Router).createUrlTree(['']);
};
